new MutationObserver(() => {
    runAccessibilityFixes();
}).observe(document.body, { childList: true, subtree: true });

runAccessibilityFixes();

function runAccessibilityFixes() {
    document.querySelectorAll('li').forEach(el => {
        if (el.getAttribute('role') === 'presentation') {
            el.removeAttribute('tabindex')
        }
    })

    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}